import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import App from "./App";
import "./index.css";
import { LayoutProvider } from "./context/LayoutContext";
import { NotificationProvider } from "./context/NotificationContext";
import "bootstrap/dist/js/bootstrap.min.js";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ProfileProvider } from "./context/ProfileContext";
import { OrgAppProvider } from "./context/OrgAppContext";

const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <OrgAppProvider>
        <AuthProvider>
          <LayoutProvider>
            <ProfileProvider>
              <NotificationProvider>
                <App />
              </NotificationProvider>
            </ProfileProvider>
          </LayoutProvider>
        </AuthProvider>
      </OrgAppProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
